var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-chevron-down",
    transform: "translate(4126 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1203",
    "data-name": "Rectangle 1203",
    width: 36,
    height: 36,
    rx: 4,
    transform: "translate(-4126 530)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chevron-sort-down",
    d: "M16.125,29.25l-6-6,1.2-1.2,4.8,4.8,4.8-4.8,1.2,1.2Z",
    transform: "translate(-4124.125 522.35)",
    fill: "#213364"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon-chevron-down.ac5313a9febe5b227935a0d5d82589df.svg";
export { ForwardRef as ReactComponent };